export default __webpack_public_path__ + "static/media/saft.75468c6e.webp";